module.exports = __webpack_public_path__ + "img/pokeybelly.b5499022.svg";